import React from 'react'

const AdminFooter = () => {
  return (
    <footer className="sticky-footer bg-white">
      <div className="container my-auto">
        <div className="copyright text-center my-auto">
          <span>Copyright © 주식회사 HY교육</span>
        </div>
      </div>
    </footer>

  )
}

export default AdminFooter